import { mapFilmToMovieSchema } from './film';
/**
 * Maps an array of @vista-digital/ocapi-types Film entities to a schema.org/ItemList of schema.org/Movie types.
 * Provides carousel format for Movies in Google Search https://developers.google.com/search/docs/data-types/movie?hl=en
 * Note that all URLs must point to the same domain to display as a carousel.
 */
export const mapFilmListToItemListSchema = (films, i18n, filmUrlFactory) => {
    const listItems = films.map((film, index) => {
        const filmUrl = filmUrlFactory === null || filmUrlFactory === void 0 ? void 0 : filmUrlFactory(film);
        return {
            '@type': 'ListItem',
            position: index + 1,
            item: mapFilmToMovieSchema(film, i18n, filmUrl)
        };
    });
    return {
        '@type': 'ItemList',
        itemListElement: listItems,
        itemListOrder: 'http://schema.org/ItemListOrderDescending',
        numberOfItems: listItems.length
    };
};
